import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { OrganizationComponent } from "./organization.component";
import { OrganizationCreateTeamComponent } from "./organization-create-team.component";
import { OrganizationSettingsComponent } from "./organization-settings.component";
import { ReactiveFormsModule } from "@angular/forms";
import { MatOption, MatSelect } from "@angular/material/select";
import { RouterLink } from "@angular/router";

@NgModule({
    declarations: [
        OrganizationComponent,
        OrganizationCreateTeamComponent,
        OrganizationSettingsComponent,
    ],
    imports: [
        CommonModule,
        TranslateModule,
        ReactiveFormsModule,
        MatSelect,
        MatOption,
        RouterLink
    ]
})
export class TmOrganizationModule{
}